// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:374px){.btn.main .btnText,.btn.main .btnText>span{font-size:var(--font-size-small)}}", ""]);
// Exports
module.exports = exports;
